import type { FC } from 'react'
import { createContext, PropsWithChildren, useMemo, useState } from 'react'
import { ICalendar } from 'pages/my-calendars/add-calendar'
import type { CalendarsStatuses } from 'shared/interfaces/types'

export interface contextProps {
    isDisableApprovedDates: boolean
    setIsDisableApprovedDates: (isDisableApprovedDates: boolean) => void
    approvedData: ICalendar[]
    setApprovedData: (approvedData: ICalendar[]) => void
    worksheetData: ICalendar[]
    setWorksheetData: (worksheetData: ICalendar[]) => void
    calendarId: string
    setCalendarId: (calendarId: string) => void
    calendarsStatuses: CalendarsStatuses
    setCalendarsStatuses: (statuses: CalendarsStatuses) => void
}

export const SupplierCalendarsContext = createContext<contextProps>({} as contextProps)

export const SupplierCalendarsContextProvider: FC<PropsWithChildren<unknown>> = ({ children }) => {
    const [isDisableApprovedDates, setIsDisableApprovedDates] = useState<boolean>(false)
    const [approvedData, setApprovedData] = useState<ICalendar[]>([])
    const [worksheetData, setWorksheetData] = useState<ICalendar[]>([])
    const [calendarId, setCalendarId] = useState('')
    const [calendarsStatuses, setCalendarsStatuses] = useState<CalendarsStatuses>({})

    const contextValue = useMemo(
        () => ({
            isDisableApprovedDates,
            setIsDisableApprovedDates,
            approvedData,
            setApprovedData,
            worksheetData,
            setWorksheetData,
            calendarId,
            setCalendarId,
            calendarsStatuses,
            setCalendarsStatuses
        }),
        [isDisableApprovedDates, approvedData, worksheetData, calendarId, calendarsStatuses]
    )

    return (
        <SupplierCalendarsContext.Provider value={contextValue}>
            {children}
        </SupplierCalendarsContext.Provider>
    )
}
